import { Floor } from '@vote4dance/judging-schema';
import { CompetitionId } from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";

export type FloorItem = Floor;

export function FloorSource(event_id: CompetitionId) {
    return new StreamSource<FloorItem[]>(`/floors/${event_id}`);
}
